export default __webpack_public_path__ + "static/3-e179bc1b859b4adf84482cd1f745a43c.jpg";